import React from 'react'
import { motion } from 'framer-motion'
import About from '../components/About'
import SEO from '../components/SEO'

const AboutPage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for About Page */}
      <SEO url="https://logicloud.mx/about" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <About />
      </motion.div>
    </>
  )
}

export default AboutPage

